import React from 'react';
import { USER_ROLE } from '../../services/auth';

const CustomerHeader = ({
  inputSearch,
  count,
  onSearchSubmit,
  onSearchTextChange,
  handleAdd,
  onClearSearch,
  statusFilter,
  onStatusFilter,
  onBack,
  branchFilter,
  onBranchFilter,
  branches,
  customer,
  showForm
}) => {

  const branchName = branches.filter(branch => branch?.id == branchFilter).name;
  const role = localStorage.getItem(USER_ROLE);
  const showBranches = role == 'admin';

  if (showForm) {
    return (
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl font-bold uppercase text-[#293686]"> {customer ? `Edit Customer(${customer.customer_code})` : "Add Customer"} </h1>
        <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
          <button
            onClick={onBack}
            className="bg-primary-light uppercase text-white px-4 py-1.5 rounded hover:bg-blue-600 text-sm"
          >
            {"< Go Back"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
      <h1 className="text-xl font-bold uppercase text-[#293686]">Customers({count})</h1>
      <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
        <form onSubmit={onSearchSubmit} className="relative w-full md:w-72">
          <input
            type="text"
            placeholder="Search by code, phone, email, etc."
            value={inputSearch}
            onChange={onSearchTextChange}
            className="border rounded w-full pl-3 pr-10 py-1.5 text-sm"
          />
          {/* Clear (X) button — appears only when there's text */}
          {inputSearch && (
            <button
              type="button"
              onClick={onClearSearch}
              className="absolute right-8 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              title="Clear"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
          <button
            type="submit"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
            title="Search"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z"
              />
            </svg>
          </button>
        </form>
        {showBranches && (
          <select
            value={branchName}
            onChange={onBranchFilter}
            className="border px-3 py-1.5 text-sm rounded uppercase"
          >
            <option value="">All Branches</option>
            {branches.map(b => (
              <option key={b.id} value={b.name}>
                {b.name}
              </option>
            ))}
          </select>
        )}
        <select
          value={statusFilter}
          onChange={onStatusFilter}
          className="border px-3 py-1.5 text-sm rounded uppercase"
        >
          <option>All</option>
          <option>Active</option>
          <option>Inactive</option>
        </select>
        <button
          onClick={handleAdd}
          className="bg-[#E91C24] uppercase text-white px-4 py-1.5 rounded hover:bg-[#E91C24] text-sm"
        >
          + Add Customer
        </button>
      </div>
    </div>
  );
};

export default CustomerHeader;
